module.exports = __webpack_public_path__ + "media/components/src/assets/images/shopping_cart/shopping_cart-e26348f6befba6171577d4f35fd766c7.svg";